interface VolumeIconWithChipInsideSVGProps {
  color: string;
  style: React.CSSProperties;
}

const VolumeIconWithChipInsideSVG = ({
  color,
  style,
}: VolumeIconWithChipInsideSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="50"
    viewBox="0 0 52 50"
    fill="none"
  >
    <g clipPath="url(#clip0_1753_36705)">
      <path
        d="M21.332 20.8936H22.8125"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.332 24.0811H22.8125"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.332 27.2686H22.8125"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.45312 24.0811H10.9335"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.45312 27.2686H10.9335"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3262 29.2754V30.7558"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.127 29.2754V30.7558"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9395 29.2754V30.7558"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3262 17.4072V18.8757"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.127 17.4072V18.8757"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.434 20.8936C15.434 22.3143 14.2879 23.4604 12.8672 23.4604V27.2809H19.2545V20.8936H15.434Z"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.0879 19.0889C45.1863 20.7961 45.831 22.8257 45.831 24.9986C45.831 27.1715 45.1863 29.2011 44.0879 30.9084"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.8496 16.0684C49.5091 18.6472 50.4762 21.7035 50.4762 24.9986C50.4762 28.2938 49.4972 31.3501 47.8496 33.9289"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.8281 22.5986C41.2699 23.2911 41.5325 24.1149 41.5325 24.9983C41.5325 25.8818 41.2699 26.7056 40.8281 27.3981"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.19853 12.4039C2.91248 12.4039 0.667969 18.7434 0.667969 24.9994C0.667969 31.2554 2.91248 37.583 7.19853 37.583H19.5075L32.6283 49.3308V29.0944H33.0581C35.3146 29.0944 37.1532 27.2558 37.1532 24.9994C37.1532 22.7429 35.3146 20.8924 33.0581 20.8924H32.6283V0.667969L19.5075 12.4039H7.19853Z"
        stroke={color}
        strokeWidth="1.33715"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1753_36705">
        <rect width="51.1461" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default VolumeIconWithChipInsideSVG;
